import { Group, Nullable, Tag } from '@brg/api';
import { bArray } from './bArray';
import { ComputedTag } from '../../shared/helpers/types/computed/ComputedTag'

/**
 * Утилиты тегов
 */
export const bTag = {
    /**
     * Возвращает идентификатор тега
     * @param tag
     */
    id(tag: Tag | Tag<'Global'>): string {
        return tag.tagId;
    },

    /**
     * Возвращает идентификаторы тегов как массив
     * @param tags
     */
    ids(tags: Array<Tag | Tag<'Global'>>): string[] {
        return tags.map(bTag.id);
    },
    /**
     * Отображает название тега согласно всем правилам
     * @param tag
     */
    title(tag?: Tag | Group): string {
        if (!tag) return '';
        //@ts-ignore
        return tag.isTranslate ? tag.name : tag.title;
    },
    /**
     * Возвращает true, если в объекте с тегами есть тег
     * @param entity
     * @param tag
     */
    isEntityHasTag(entity: Nullable<{ tags?: Array<Tag | Tag<'Global'>> } & any>, tag: Tag | Tag<'Global'>): boolean {
        if (entity && 'tags' in entity && bArray.isArray(entity.tags)) {
            return entity.tags.some((t: Tag | Tag<'Global'>) => t.tagId === tag.tagId);
        }
        return false;
    },
    /**
     * Возвращает true, если тег находится в коллекции
     * @param butch
     * @param needle
     */
    isButchHasTag(butch: Array<Tag | Tag<'Global'>>, needle: Tag | Tag<'Global'>): boolean {
        return butch.some((t) => t.tagId === needle.tagId);
    },
    /**
     * Собирает теги из коллекции сущностей с тегами
     * @param entities
     */
    fromEntityCollection(
        entities: Nullable<Array<{ tags?: Array<Tag | Tag<'Global'>> } & any>>,
    ): Array<Tag | Tag<'Global'>> {
        const instantCollection: Array<Tag | Tag<'Global'>> = [];
        if (entities) {
            for (const entity of entities) {
                if ('tags' in entity && bArray.isArray(entity.tags)) {
                    for (const tag of entity.tags) {
                        if (!bTag.isButchHasTag(instantCollection, tag)) instantCollection.push(tag);
                    }
                }
            }
        }
        return instantCollection;
    },

    sortTagsByPosition: (tag: (Tag | ComputedTag)[]): (Tag | ComputedTag)[] =>
      tag.sort((a, b) => a.position - b.position),
};
import { Group, Nullable, Tag } from '@brg/api';
import { bArray } from './bArray';
import { ComputedTag } from '../../shared/helpers/types/computed/ComputedTag'

/**
 * Утилиты тегов
 */
export const bTag = {
    /**
     * Возвращает идентификатор тега
     * @param tag
     */
    id(tag: Tag | Tag<'Global'>): string {
        return tag.tagId;
    },

    /**
     * Возвращает идентификаторы тегов как массив
     * @param tags
     */
    ids(tags: Array<Tag | Tag<'Global'>>): string[] {
        return tags.map(bTag.id);
    },
    /**
     * Отображает название тега согласно всем правилам
     * @param tag
     */
    title(tag?: Tag | Group): string {
        if (!tag) return '';
        //@ts-ignore
        return tag.isTranslate ? tag.name : tag.title;
    },
    /**
     * Возвращает true, если в объекте с тегами есть тег
     * @param entity
     * @param tag
     */
    isEntityHasTag(entity: Nullable<{ tags?: Array<Tag | Tag<'Global'>> } & any>, tag: Tag | Tag<'Global'>): boolean {
        if (entity && 'tags' in entity && bArray.isArray(entity.tags)) {
            return entity.tags.some((t: Tag | Tag<'Global'>) => t.tagId === tag.tagId);
        }
        return false;
    },
    /**
     * Возвращает true, если тег находится в коллекции
     * @param butch
     * @param needle
     */
    isButchHasTag(butch: Array<Tag | Tag<'Global'>>, needle: Tag | Tag<'Global'>): boolean {
        return butch.some((t) => t.tagId === needle.tagId);
    },
    /**
     * Собирает теги из коллекции сущностей с тегами
     * @param entities
     */
    fromEntityCollection(
        entities: Nullable<Array<{ tags?: Array<Tag | Tag<'Global'>> } & any>>,
    ): Array<Tag | Tag<'Global'>> {
        const instantCollection: Array<Tag | Tag<'Global'>> = [];
        if (entities) {
            for (const entity of entities) {
                if ('tags' in entity && bArray.isArray(entity.tags)) {
                    for (const tag of entity.tags) {
                        if (!bTag.isButchHasTag(instantCollection, tag)) instantCollection.push(tag);
                    }
                }
            }
        }
        return instantCollection;
    },

    sortTagsByPosition: (tag: (Tag | ComputedTag)[]): (Tag | ComputedTag)[] =>
      tag.sort((a, b) => a.position - b.position),
};
